import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import ExecutiveSearch from './pages/ExecutiveSearch';
import Mentora from './pages/Mentora';
import TechRecruitment from './pages/TechRecruitment';
import RPO from './pages/RPO';
import LabourContractor from './pages/LabourContractor';
import PayrollOutsourcing from './pages/PayrollOutsourcing';
import StartupConsultancy from './pages/StartupConsultancy';
import ODConsultancy from './pages/ODConsultancy';
import PerformanceManagement from './pages/PerformanceManagement';
import HRPolicy from './pages/HRPolicy';
import TrainingSolutions from './pages/TrainingSolutions';
import './App.css';

function App() {
  useEffect(() => {
    // Add smooth scrolling behavior
    document.documentElement.style.scrollBehavior = 'smooth';
    
    // Add notification styles to head
    const style = document.createElement('style');
    style.textContent = `
      @keyframes slideInRight {
        from {
          transform: translateX(100%);
          opacity: 0;
        }
        to {
          transform: translateX(0);
          opacity: 1;
        }
      }
      
      .notification-content {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 1rem;
      }
      
      .notification-close {
        background: none;
        border: none;
        color: white;
        font-size: 1.5rem;
        cursor: pointer;
        padding: 0;
        width: 20px;
        height: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        transition: background-color 0.3s ease;
      }
      
      .notification-close:hover {
        background-color: rgba(255, 255, 255, 0.2);
      }

      /* Fade in animation */
      @keyframes fadeInUp {
        from {
          opacity: 0;
          transform: translateY(30px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }
      
      .fade-in-up {
        animation: fadeInUp 0.6s ease-out;
      }
    `;
    document.head.appendChild(style);

    // Intersection Observer for fade-in animations
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('fade-in-up');
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    // Observe elements for animation
    const elementsToAnimate = document.querySelectorAll('.service-card, .about-content, .contact-content, .section-header');
    elementsToAnimate.forEach(el => {
      observer.observe(el);
    });

    // Cleanup
    return () => {
      document.head.removeChild(style);
    };
  }, []);

  return (
    <Router>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/executive-search" element={<ExecutiveSearch />} />
          <Route path="/mentora" element={<Mentora />} />
          <Route path="/tech-recruitment" element={<TechRecruitment />} />
          <Route path="/recruitment-process-outsourcing" element={<RPO />} />
          <Route path="/rpo" element={<RPO />} />
          <Route path="/labor-contractor" element={<LabourContractor />} />
          <Route path="/labour-contractor" element={<LabourContractor />} />
          <Route path="/payroll-outsourcing" element={<PayrollOutsourcing />} />
          <Route path="/startup-consultancy" element={<StartupConsultancy />} />
          <Route path="/startup-growth-consultancy" element={<StartupConsultancy />} />
          <Route path="/od-consultancy" element={<ODConsultancy />} />
          <Route path="/performance-management" element={<PerformanceManagement />} />
          <Route path="/hr-policy" element={<HRPolicy />} />
          <Route path="/hr-policy-management" element={<HRPolicy />} />
          <Route path="/training-solutions" element={<TrainingSolutions />} />
          <Route path="/specialized-training-solutions" element={<TrainingSolutions />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
